export const UPDATES = ['updates'];